//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { BatchUpdateModerationStatusRequest } from '@apis/moderation/moderationApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const MODERATION_BASE = '/api/v1/moderation';

const moderationGatewayFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'moderation_gateway',
    `${MODERATION_BASE}${endpoint}`,
    init,
  );
};

/**
 * Batch update moderation status for content items.
 *
 * PATCH /api/v1/moderation/status
 *
 * Returns 204 No Content on success.
 */
export const batchUpdateModerationStatus = async (
  req: BatchUpdateModerationStatusRequest,
  init?: RequestInit,
): Promise<void> => {
  await moderationGatewayFetch('/status', {
    ...init,
    method: 'PATCH',
    body: JSON.stringify(req),
  });
};
